<template>
  <v-switch inset v-model="dummyFlag">
    <template v-slot:label>
      {{ label }} &nbsp;<v-icon size="18">lock</v-icon>
    </template>
  </v-switch>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dummyFlag: false,
    }
  },
  methods: {
  },
  watch: {
    dummyFlag(flag) {
      if (flag) {
        // prevent flicking the switch by setting it back to false
        this.$nextTick(() => {
          this.dummyFlag = false;
        })
        // show locked feature message
        this.$store.commit('general/showLockedFeatureDialog', this.type);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input--switch {
  margin-top: 0;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/LockedFeatureSwitch.vue